<template>
  <div class="svg-button d-flex align-items-center">
    <template v-if="attachment.url">
      <template v-if="attachment.type === 'image'">
        <img
          :src="attachment.url + '_small'"
          height="45"
        >
        <button
          type="button"
          class="btn btn-link text-decoration-none font-size-16 text-danger"
          @click="onReset"
        >
          <i class="ri-delete-bin-5-line" />
        </button>
      </template>
      <template v-if="attachment.type === 'video'">
        <img
          :src="attachment.url_thumbnail"
          height="45"
        >
        <button
          type="button"
          class="btn btn-link text-decoration-none font-size-16 text-danger"
          @click="onReset"
        >
          <i class="ri-delete-bin-5-line" />
        </button>
      </template>
      <template v-if="attachment.type === 'document'">
        <img
          src="@/static/document.svg"
          height="32"
        >
        <button
          type="button"
          class="btn btn-link text-decoration-none font-size-16 text-danger"
          @click="onReset"
        >
          <i class="ri-delete-bin-5-line" />
        </button>
      </template>
    </template>

    <template v-else>
      <b-dropdown
        dropup
        variant="outline-default"
        toggle-class="btn btn-link text-decoration-none font-size-16"
      >
        <template slot="button-content">
          <i class="ri-attachment-line" />
        </template>
        <b-dropdown-item
          type="button"
          @click="showImage = true"
        >
          <i class="icon-image2 mr-2" />
          {{ $t(`${tt}.attach_image.btn_select`) }}
        </b-dropdown-item>
        <b-dropdown-item
          type="button"
          @click="showVideo = true"
        >
          <i class="icon-image2 mr-2" />
          {{ $t(`${tt}.attach_video.btn_select`) }}
        </b-dropdown-item>
        <b-dropdown-item
          v-if="showBtnDocument"
          type="button"
          @click="showDocument = true"
        >
          <i class="icon-image2 mr-2" />
          {{ $t(`${tt}.attach_document.btn_select`) }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <ModalImage
      :show.sync="showImage"
      @input="onSelect"
    />
    <ModalVideo
      :show.sync="showVideo"
      @input="onSelect"
    />
    <ModalDocument
      :show.sync="showDocument"
      @input="onSelect"
    />
  </div>
</template>

<script>
import ModalImage from './ImageAttachFooterRoomComponents';
import ModalVideo from './VideoAttachFooterRoomComponents';
import ModalDocument from './DocumentAttachFooterRoomComponents';
import {mapState} from "vuex";

export default {
  components: {
    ModalImage,
    ModalVideo,
    ModalDocument,
  },
  props: {
    attachment: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    tt: 'room.footer.attach',
    showImage: false,
    showVideo: false,
    showDocument: false,
  }),
  computed: {
    selectedRoomId() {
      return this.$store.state.rooms.selectedRoomId;
    },
    room() {
      return this.$store.state.rooms.rooms[this.selectedRoomId];
    },
    showBtnDocument() {
      try {
        return ['viber', 'whatsapp'].includes(this.room.channel_name.toLowerCase());
      } catch (e) {
        return false;
      }
    },
  },
  methods: {
    onSelect(item) {
      this.show = false;
      this.$emit('select', item);
    },
    onReset() {
      this.$emit('select', undefined);
    },
  },
};
</script>

<style scoped>
.file-upload {
  position: relative;
  cursor: pointer;
}

.file-upload input[type=file] {
  -webkit-appearance: none;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.card-img-actions {
  position: relative;
}

.card-img-actions:hover .card-img-actions-overlay,
.card-img-actions:focus .card-img-actions-overlay {
  opacity: 1;
  visibility: visible;
}

.card-img-actions-overlay {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  opacity: 0;
  visibility: hidden;
  transition: all ease-in-out 0.15s;
}

@media screen and (prefers-reduced-motion: reduce) {
  .card-img-actions-overlay {
    transition: none;
  }
}

.border-2 {
  border: 2px solid;
}
</style>
